var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.625L8.93875 7.56375L11.125 5.39125L11.125 16.625L13.875 16.625L13.875 5.39125L16.0475 7.56375L18 5.625L12.5 0.124999L7 5.625ZM2.875 22.125L2.875 12.5L0.124999 12.5L0.125 22.125C0.125 23.6375 1.3625 24.875 2.875 24.875L22.125 24.875C23.6375 24.875 24.875 23.6375 24.875 22.125L24.875 12.5L22.125 12.5L22.125 22.125L2.875 22.125Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.37d197ed9236bfd978a3c063fa78c87c.svg";
export { ForwardRef as ReactComponent };